
import './App.css';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Navigation from './Components/Navigation';
import Home from './Pages/Home';
import Footer from './Components/Footer';
import About from './Pages/About';
import Contact from './Pages/Contact';
import Services from './Pages/Services';
import Annual from './Components/Annual';
import Hydrant from './Components/Hydrant';
import Fire from './Components/Fire';
import Plumbing from './Pages/Plumbing';
import Hvac from './Pages/Hvac';
import Electrical from './Pages/Electrical';
import Gallery from './Pages/Gallery';
import Warehouse from './Components/Warehouse';
import Firehydrant from './Components/Firehydrant';
import Sprinkler from './Components/Sprinkler';


function App() {
  return (
    <div>
      <Router> 
      <Navigation />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/about' element={<About />} />
        <Route path='/services' element={<Services />} />
        <Route path='/annual' element={<Annual />} />
        <Route path='/hydrant' element={<Hydrant />} />
        <Route path='/fire' element={<Fire />} />
        <Route path='/plumbing' element={<Plumbing />} />
        <Route path='/hvac' element={<Hvac />} />
        <Route path='/electrical' element={<Electrical />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/gallery' element={<Gallery />} />
        <Route path='/warehouse' element={<Warehouse />} />
        <Route path='/firehydrant' element={<Firehydrant />} />
        <Route path='/sprinkler' element={<Sprinkler />} />
      </Routes>
      <Footer />
    </Router> 
    </div>
  );
}

export default App;
